export type FaceBookMeta = {
  appId: string,
  pageId: string
};

export type GetFacebookMeta = (siteBranchId: number) => FaceBookMeta;

/* Facebook Page ids depending on SiteBranch ID */
const COUNTRY_FACEBOOK_PAGE_ID: Record<string, string> = {
  0: '107455249877', //DE
  16: '107455249877', //AT
  17: '107455249877', //CH
  14: '262172985526', //NL
  38: '262172985526', //NLBE
  18: '12984297326', //UK
  24: '131270317604', //FR
  37: '131270317604', //FRBE
  47: '165358573676', //IT
  48: '110945155591904', //ES
  51: '20389222392', //DK
  52: '7664213254', //SE
  53: '11516054306', //NO
  61: '161925737181545', //FI
};

const COUNTRY_FACEBOOK_APP_ID: Record<string, string> = {
  0: '196203673756400', //DE
  16: '214047721952846', //AT
  17: '195653343812689', //CH
};

export function getFacebookMeta(siteBranchId: number): FaceBookMeta {
  return {
    pageId:  COUNTRY_FACEBOOK_PAGE_ID[siteBranchId],
    appId: COUNTRY_FACEBOOK_APP_ID[siteBranchId]
  };
}

